<i class="icon-exclamation-circle validation-icon-new" [ngClass]="getValidationClassName()" [tooltip]="{text: messages, color: violation}">
    <ng-content select="counter"></ng-content>
</i>